<template>
    <Modal :visible="$userStore.isComingSoonModalVisible" @close="closeModal">
        <div
            class="d-flex flex-column align-items-center justify-content-center"
        >
            <i
                class="fi fi-lg fi-clock mb-2"
                style="
                    font-size: 40px;
                    line-height: 40px;
                    font-weight: 200;
                    color: var(--warning);
                "
            ></i>
            <h2 class="my-1">Coming Soon!</h2>
            <div class="my-2 text-center" style="color: var(--neutral-800)">
                We’re working hard to bring you this new feature. Stay tuned!
            </div>
            <div class="d-flex gap-2">
                <a
                    href="https://ipacdashboard.com/#subscribe-to-newsletter"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="btn btn-primary"
                >
                    Notify Me
                </a>
                <button
                    class="btn btn-desktop-lg btn-white"
                    @click="closeModal"
                >
                    Got it
                </button>
            </div>
        </div>
    </Modal>
</template>

<script>
import Modal from '@/components/Modal.vue';

export default {
    name: 'ComingSoonModal',
    components: {
        Modal,
    },
    props: {},
    emits: [],
    methods: {
        closeModal() {
            this.$userStore.toggleComingSoonModal(false);
        },
    },
};
</script>
